import { connect } from 'react-redux';
import type { Facet, OverrideValues, AccommodationState, HotelFacet } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { type CheckboxDispatchProps, CheckboxFilter, type CheckboxStateProps } from '@/components/checkboxFilter/CheckboxFilter';
import type { ActionCreator } from 'redux';

import displayValues from '@/assets/displayValues.json';

const findAllPropertyTypeIds = (displayName: string): readonly string[] =>
    Object.keys(displayValues.propertyTypes).reduce(
        (ids: readonly string[], key: string): readonly string[] =>
            displayValues.propertyTypes[key].enabled && displayValues.propertyTypes[key].displayName === displayName
                ? ids.concat([key])
                : ids,
        [],
    );

const findPropertyTypeCount = (propertyTypes: readonly HotelFacet[], ids: readonly string[]): number =>
    propertyTypes
        .filter((propertyType) => ids.includes(propertyType.id.toString()))
        .reduce((sum: number, propertyType: HotelFacet): number => sum + propertyType.hotelCount, 0);

export const mapPropertyTypes = (propertyTypes: readonly HotelFacet[]): readonly Facet[] => {
    const enabledPropertyTypes = (propertyTypes || [])
        .map((propertyType) => displayValues.propertyTypes[propertyType.id])
        .filter((propertyType) => propertyType?.enabled);
    const propertyTypesWithoutDuplicates = enabledPropertyTypes.filter(
        (feature, index) => enabledPropertyTypes.findIndex((elem) => elem.displayName === feature.displayName) === index,
    );
    return propertyTypesWithoutDuplicates.map((propertyType) => {
        const ids = findAllPropertyTypeIds(propertyType.displayName);
        return {
            value: ids.join('|'),
            count: findPropertyTypeCount(propertyTypes, ids),
            displayValue: propertyType.displayName,
        };
    });
};

export const mapStateToProps = (state: AccommodationState): CheckboxStateProps => ({
    id: 'PropertyTypeFilter',
    label: 'Type overnatting',
    facetList: mapPropertyTypes(state.searchResults.propertyTypes),
    checkboxValues: state.filters.propertyType,
    hideLabel: true,
    alwaysExpanded: true,
});

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterPropertyType,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
